import EditArtistContainer from "../containers/EditArtistContainer";

const EditArtistPage = () => {
  return (
    <EditArtistContainer />
  );
};

export default EditArtistPage;
